export const generateCoverSrc = (asin: string) =>
  `https://images-na.ssl-images-amazon.com/images/P/${asin}.01._SX255_SY255_TTXW_SCLZZZZZZZ_.jpg`

export const generateListingUrl = (asin: string) =>
  `https://www.amazon.com/gp/product/${asin}`
